import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Orders from './views/Orders.vue'
import OrdersToSend from './views/OrdersToSend.vue'
import OrdersObserved from './views/OrdersObserved.vue'
import OrdersToReceive from './views/OrdersToReceive.vue'
import LoginPage from './views/LoginPage.vue'
import RecoverPassword from './views/RecoverPassword.vue'
import RecoverPasswordNew from './views/RecoverPasswordNew.vue'
import Map from './views/Map.vue'
import Coupons from './views/Coupons.vue'
import Logout from './views/Logout.vue'
import ClaimOrder from './views/Claim.vue'

Vue.use(Router)


/*
    This will cehck to see if the user is authenticated or not.
*/
function checkLogin (to, from, next) {
  if(to.matched.some(function(record){
    if(record.meta.requiresAuth == true){
      let token = Vue.ls.get('token');
      if ( token != null && token != '' ) {
        next();
      } else {
        next('/login');
      }
    }
    else{
      next();
    }
  }));
  next();
}


export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home',
      meta: {
        requiresAuth: true,
      },
      beforeEnter: checkLogin
    },
    {
      path: '/login',
       name: 'login',
       component: LoginPage,
       beforeEnter: checkLogin,
       meta: {
        requiresAuth: false,
      }
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      beforeEnter: checkLogin,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/recoverPassword',
      name: 'recoverPassword',
      component: RecoverPassword,
      meta: {
        requiresAuth: false,
      }
    },

    {
      path: '/recoverPasswordNew',
      name: 'recoverPasswordNew',
      component: RecoverPasswordNew,
      meta: {
        requiresAuth: false,
      }
    },
    {
      path: '/myOrders',
      name: 'orders',
      component: Orders,
      beforeEnter: checkLogin,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/ordersObserved',
      name: 'ordersObserved',
      component: OrdersObserved,
      beforeEnter: checkLogin,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/ordersToSend',
      name: 'ordersToSend',
      component: OrdersToSend,
      beforeEnter: checkLogin,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/ordersToReceive',
      name: 'ordersToReceive',
      component: OrdersToReceive,
      beforeEnter: checkLogin,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/map',
      name: 'map',
      component: Map,
      beforeEnter: checkLogin,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/about',
      name: 'about',
      beforeEnter: checkLogin,
      meta: {
        requiresAuth: false,
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/coupons',
      name: 'coupons',
      beforeEnter: checkLogin,
      meta: {
        requiresAuth: true,
      },
      component: Coupons
    },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter: checkLogin,
      component: Logout,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/ClaimOrder',
      name: 'ClaimOrder',
      beforeEnter: checkLogin,
      component: ClaimOrder,
      props: true,
      meta: {
        requiresAuth: true,
      },
    }
  ]
});
